import { useAuth } from '../contexts/AuthContext';

// Interceptor para manejar respuestas HTTP y errores de token
export const createApiInterceptor = (logout: () => void) => {
  return async (url: string, options: RequestInit = {}) => {
    try {
      const response = await fetch(url, options);
      
      // Si la respuesta es 401 (Unauthorized), el token ha expirado
      if (response.status === 401) {
        console.log('Token expirado, redirigiendo al login');
        logout();
        throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
      }
      
      return response;
    } catch (error) {
      // Si hay un error de red, también podríamos querer hacer logout
      if (error instanceof TypeError && error.message.includes('fetch')) {
        console.log('Error de red, verificando sesión');
        logout();
        throw new Error('Error de conexión. Por favor, verifica tu conexión e inicia sesión nuevamente.');
      }
      
      throw error;
    }
  };
};

// Hook personalizado para usar el interceptor
export const useApiInterceptor = () => {
  const { logout } = useAuth();
  return createApiInterceptor(logout);
}; 